export interface AuthProviders {
  AuthProvider: string;
  CustomerID: string;
  LabelText: string;
  OrgID: string;
  ProviderName: AuthProvidersTypes;
  _id: string;
}

export enum AuthProvidersTypes {
  sirsiWeb = "SirsiWeb",
  sirsi = "Sirsi",
  gsuite = "Gsuite",
  sirsiBarcodeOnly = "Sirsi-BarcodeOnly",
  internal = "Internal",
  oidc = "Oidc",
  saml = "Saml",
  ldap = "Ldap",
  azureAD = "AzureAD",
  innovative = "Innovative",
  polaris = "Polaris",
  polarisWeb = "PolarisWeb",
}
